// lib
import { connect } from "react-redux";
import { withRouter } from "react-router";
// src
import Component from "components/partials/AppBar";
import { loginAndKeepPath } from "actions/user/thunks";
import { setLanguage } from "actions/ux";

const mapStateToProps = ({
  presets: { isLight },
  system: { isHydrated },
  user: { identity, isLogged },
  ux: { isLarge, isXSmall, language },
}) => ({
  identity,
  isLight,
  isHydrated,
  isLarge,
  isLogged,
  isXSmall,
  language,
});

const mapDispatchToProps = {
  loginAndKeepPath,
  setLanguage,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Component));
